module.exports = __webpack_public_path__ + "img/linkedin-icon-black.9f119079.svg";